import React from "react";

const GoogleSheetsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.81627 0L13.8163 4L11.8163 4.36364L9.81627 4L9.45264 2L9.81627 0Z",
  fill: "#188038"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8163 4V0H3.27084C2.66811 0 2.17993 0.488182 2.17993 1.09091V14.9091C2.17993 15.5118 2.66811 16 3.27084 16H12.7254C13.3281 16 13.8163 15.5118 13.8163 14.9091V4H9.8163Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.36182 6.18164V11.4544H11.6345V6.18164H4.36182ZM7.54363 10.5453H5.27091V9.27255H7.54363V10.5453ZM7.54363 8.36346H5.27091V7.09073H7.54363V8.36346ZM10.7255 10.5453H8.45272V9.27255H10.7255V10.5453ZM10.7255 8.36346H8.45272V7.09073H10.7255V8.36346Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleSheetsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;